<div class="wrapper">
    <!-- Chọn ngôn ngữ -->
    <div class="mb-3">
        <app-select-language-config [isAdmin]="true"></app-select-language-config>
    </div>
    <div class="main-menu">
        <!-- Thêm menu -->
        <div class="select-link-page">
            <!-- Nhóm (group) -->
            <div class="content-left">
                <nz-radio-group style="display:grid; gap:5px; margin-top:15px;"
                    [(ngModel)]="data.menu.group"
                    (ngModelChange)="changeGroupAndType()">
                    <ng-container *ngFor="let item of listGroupLink">
                        <label nz-radio *ngIf="data.menu.groups.includes(item.url)" [nzValue]="item.url">{{item.name | translate}}</label>
                    </ng-container>
                </nz-radio-group>
            </div>
            <div class="content-right">
                <!-- Danh sách loại link (type) -->
                <div class="fill-name-menu">
                    <nz-radio-group nzName="radiogroup"
                        [(ngModel)]="data.menu.type"
                        (ngModelChange)="changeGroupAndType()">
                        <label nz-radio *ngFor="let link of listLink" [nzValue]="link.url">{{link.name | translate}}</label>
                    </nz-radio-group>
                </div>
                <!-- Tên menu -->
                <div class="fill-name-menu">
                    <p class="title-name">{{'ten_menu' | translate}}:</p>
                    <input nz-input class="field-fill" placeholder="{{'nhap_ten_menu' | translate}}"
                        [(ngModel)]="data.menu['name_' + functionService.selectedLanguageCode]"
                        (input)="onChangeAttr()" />
                </div>
                <!-- Nhóm: Đường dẫn (link) -->
                <div class="connect-page">
                    <!-- Chọn liên kết loại Không (none) -->
                    <div class="group-link" *ngIf="data.menu.type == 'none'">
                    </div>
                    <!-- Chọn liên kết loại Đến trang (link-page) -->
                    <div class="group-link" *ngIf="data.menu.type == 'link-page'">
                        <!-- Trang liên kết -->
                        <div class="fill-name-menu">
                            <p class="title-name">{{'trang_lien_ket' | translate}}:</p>
                            <div class="elementor-select">
                                <nz-select nzAllowClear class="field-fill" style="width:100%"
                                    [nzPlaceHolder]="data.menu.link_page ? data.menu.link_page : ('chon_trang_lien_ket' | translate)"
                                    [(ngModel)]="data.menu.link_page"
                                    (ngModelChange)="onChangeAttr()">
                                    <nz-option *ngFor="let page of listLinkPage"
                                        [nzLabel]="page.name | translate"
                                        [nzValue]="page._id || ''"></nz-option>
                                </nz-select>
                            </div>
                        </div>
                    </div>
                    <!-- Chọn liên kết loại Liên kết (website) -->
                    <div class="group-link" *ngIf="data.menu.type == 'website'">
                        <!-- Liên kết Website -->
                        <div class="fill-name-menu">
                            <p class="title-name">{{'lien_ket_website' | translate}}:</p>
                            <div class="elementor-select">
                                <input nz-input class="field-fill" placeholder="Nhập liên kết"
                                    style="border-top-left-radius: 0px;border-bottom-left-radius: 0px;"
                                    [(ngModel)]="data.menu.link_website"
                                    (input)="onChangeAttr()" />
                            </div>
                        </div>
                    </div>
                    <!-- Chọn liên kết loại URL (link-url) -->
                    <div class="group-link" *ngIf="data.menu.type == 'link-url'">
                        <!-- Link sản phẩm -->
                        <div class="fill-name-menu">
                            <p class="title-name">{{'link_san_pham' | translate}}:</p>
                            <div class="elementor-select">
                                <input nz-input class="field-fill" placeholder="/ten-trang-chi-tiet-san-pham/ten-san-pham"
                                    style="border-top-left-radius: 0px; border-bottom-left-radius: 0px"
                                    [(ngModel)]="data.menu.link_url"
                                    (input)="onChangeAttr()" />
                            </div>
                        </div>
                    </div>

                    <div class="fill-name-menu" *ngIf="data.menu.type != 'none'">
                        <p class="title-name">{{'hanh_dong_khi_nhan' | translate}}:</p>
                        <div class="elementor-select">
                            <nz-select nzAllowClear class="field-fill" style="width:100%"
                                [nzPlaceHolder]="'cuon_len_dau_trang' | translate"
                                [(ngModel)]="data.menu.is_scroll"
                                (ngModelChange)="onChangeAttr()">
                                <nz-option [nzLabel]="'cuon_len_dau_trang' | translate" [nzValue]="true"></nz-option>
                                <nz-option [nzLabel]="'giu_nguyen_vi_tri' | translate" [nzValue]="false"></nz-option>
                            </nz-select>
                        </div>
                    </div>
                </div>
                <!-- Nhóm: Gọi danh mục (category) -->
                <div class="connect-category" *ngIf="data.menu.group == 'category'">
                    <!-- Các danh mục con sẽ dẫn tới trang -->
                    <div class="fill-name-menu">
                        <p class="title-name">{{'cac_danh_muc_con_se_dan_toi_trang' | translate}}:</p>
                        <nz-select nzAllowClear class="field-fill"
                            nzPlaceHolder="chon_trang_danh_muc"
                            [(ngModel)]="data.menu.id_page_category"
                            (ngModelChange)="onChangeAttr()">
                            <nz-option *ngFor="let page of listPageCategory"
                                [nzLabel]="page.name"
                                [nzValue]="page._id"></nz-option>
                        </nz-select>
                    </div>
                </div>
                <!-- Nhóm: Gọi hộp thoại (pop-up) -->
                <div class="connect-popup" *ngIf="data.menu.group == 'pop-up'" style="display: flex; align-items: flex-end; gap: 20px; margin-top: 15px">
                    <!-- Hộp thoại -->
                    <div class="fill-name-menu">
                        <p class="title-name">{{'hop_thoai' | translate}}:</p>
                        <nz-select nzAllowClear class="field-fill"
                            nzPlaceHolder="{{'chon_hop_thoai_hien_thi' | translate}}"
                            [(ngModel)]="data.menu.id_popup"
                            [(ngModel)]="data.menu.id_freeblock"
                            (ngModelChange)="onChangeAttr()">
                            <nz-option *ngFor="let block of listBlockPopup"
                                [nzValue]="block._id"
                                [nzLabel]="block.name"></nz-option>
                        </nz-select>
                    </div>
                    <button [disabled]="type == 'build'" nz-button nzType="primary" (click)="createNewBlock()">{{'tao_hop_thoai' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="button-add" style="display:flex;align-items: center;justify-content: flex-end;gap:5px;margin-top: 15px;">
    <button nz-button (click)="cancelFormAddMenu()">{{'huy' | translate}}</button>
    <button nz-button nzType="primary" [disabled]="!isValid" (click)="saveFormAddMenu()">{{'luu' | translate}}</button>
</div>